import React, { useState, useRef } from "react";
import { MdLoop } from "react-icons/md";

const Audio = ({
  className,
  source,
  type,
}: {
  className?: string;
  source: string;
  type?: string;
}) => {
  const [isLooping, setIsLooping] = useState(false);
  const audioRef = useRef<HTMLAudioElement | null>(null);

  const handlePlay = () => {
    if (audioRef.current) {
      audioRef.current.play().catch((error) => {
        console.error("Playback failed:", error);
      });
    }
  };

  const fileType = () => {
    const fileExtension = source.split(".").pop();
    if (fileExtension === "m4a") {
      return "audio/x-m4a";
    } else if (fileExtension === "mp3") {
      return "audio/mp3";
    }
    return "audio/mp3";
  };

  return (
    <div className="flex flex-row items-center gap-2">
      <audio
        ref={audioRef}
        className={className}
        controls
        controlsList="nodownload"
        loop={isLooping}
        onPlay={handlePlay}
      >
        <source src={source} type={type || fileType()} />
        Your browser does not support the audio tag.
      </audio>
      <MdLoop
        className={`rounded-full h-12 w-12 p-2 cursor-pointer hover:bg-gray-200 ${
          isLooping ? "text-blue-600 bg-blue-200" : "text-gray-400"
        }`}
        onClick={() => setIsLooping(!isLooping)}
        aria-label="Toggle Loop"
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            setIsLooping(!isLooping);
          }
        }}
      />
    </div>
  );
};

export default Audio;
